import { Module } from "vuex";
import { actions, APPLICATION_ACTIONS } from "./actions";
import { getters, APPLICATION_GETTERS } from "./getters";
import { mutations, APPLICATION_MUTATIONS } from "./mutations";
import { IApplicationState } from "./types";
import { IRootState } from "@/store/types";
import { cloneDeep } from "@/helpers/object";

export const state: IApplicationState = {
  isLoading: false,
  applicationsList: [],
  applicationsListTotal: 0,
  cardAccountSetupTask: null,
  modifyAccountNumberTask: null,
  jdeAccountSetupTask: null,
  myApplicationsList: [],
  myApplicationsListTotal: 0,
  completedApplicationsList: [],
  completedApplicationsListTotal: 0,
  draftsList: [],
  draftsListTotal: 0,
  applicationData: null,
  applicationDataOriginal: null,
  requestForCallbackTask: null,
  physicalAddressLookup: null,
  physicalAddressLookupIsLoading: false,
  deliveryAddressLookup: null,
  deliveryAddressLookupIsLoading: false,
  creditOutcomeTask: null,
  followUpPersonalGuaranteeTask: null,
  showAssignToMeConfirmation: false,
  dataTables: {
    myApplications: {
      statusFilters: null,
      pagination: {
        sortBy: "submittedDate",
        descending: false
      }
    },
    allApplications: {
      statusFilters: null,
      pagination: {
        sortBy: "updatedDate"
      }
    },
    drafts: {
      statusFilters: null,
      pagination: {
        sortBy: "createdDate"
      }
    },
    completed: {
      statusFilters: null,
      pagination: {
        sortBy: "updatedDate"
      }
    }
  },
  activeApplicationTab: null
};

export namespace APPLICATION {
  export const ACTIONS = APPLICATION_ACTIONS;
  export const GETTERS = APPLICATION_GETTERS;
  export const MUTATIONS = APPLICATION_MUTATIONS;
  export const NAME_SPACE = "application";
  export const NS = (x: string): string => `${NAME_SPACE}/${x}`;
}

const namespaced: boolean = true;

export const application: Module<IApplicationState, IRootState> = {
  namespaced,
  state: cloneDeep(state), // create a deep clone of state object so we can reuse the state object
  getters,
  actions,
  mutations
};
